var l = /* @__PURE__ */ ((O) => (O.PRODUCTION = "production", O.BLUE = "blue", O.HML = "hml", O.LOCAL = "local", O))(l || {});
const C = "CONFIG";
export {
  C as CONFIG,
  l as EnvironmentType
};
